import { render } from "./Saruman-ModeloTCPIPView.vue?vue&type=template&id=16573b11&scoped=true"
import script from "./Saruman-ModeloTCPIPView.vue?vue&type=script&lang=js"
export * from "./Saruman-ModeloTCPIPView.vue?vue&type=script&lang=js"

import "./Saruman-ModeloTCPIPView.vue?vue&type=style&index=0&id=16573b11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16573b11"]])

export default __exports__